import React from 'react'

// import { style } from '../../components/home/Index.style'
import Page from '../../components/Page/Page'
import Content from '../../components/Content/Content'
import BackNumber from '../../components/BackNumber/BackNumber'

const pageTitle = 'バックナンバー一覧 | 新潟県民だより'


const Home = () => {
  return (
    <Page title={pageTitle}>
      <Content>
        <BackNumber max={0} ttl="バックナンバー 一覧" isViewList={false} />
      </Content>
    </Page>
  )
}
export default Home